// Styles
import { getClassNames, getStyles } from "./SimpleBreadcrumb.styles";
import { chevronRightExtraSmallIcon } from "../../../icons/icons.styles";
// Utilities
import * as React from "react";
import { Icon, useTheme } from "@fluentui/react";
import { getBreadcrumbString } from "@ms/uno-utilities/lib/local/StringUtilities";
/**
 * Renders the a string-only breadcrumb with chevrons between each item
 */ export const SimpleBreadcrumb = (props)=>{
    const { breadcrumbStrings, keySuffix, styles } = props;
    // Get styles and classnames
    const { root, item, chevron, wrapper } = getClassNames(getStyles(useTheme(), styles));
    return /*#__PURE__*/ React.createElement("div", {
        className: root
    }, /*#__PURE__*/ React.createElement("div", {
        className: wrapper,
        title: getBreadcrumbString(breadcrumbStrings)
    }, breadcrumbStrings.map((breadcrumb, index)=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: `${keySuffix}${index}`
        }, index !== 0 && /*#__PURE__*/ React.createElement("div", {
            className: chevron
        }, /*#__PURE__*/ React.createElement(Icon, chevronRightExtraSmallIcon)), /*#__PURE__*/ React.createElement("span", {
            className: item
        }, breadcrumb));
    })));
};
